export default "__VITE_ASSET__D$NlWlL5__$_?component__"